import { jsx as _jsx } from "react/jsx-runtime";
import "./PayoutSellerStatistics.css";
import PayoutStatistics from '../PayoutStatistics';
import { getUserAvatar } from "../../../helpers/renderPayoutNotification";
const PayoutSellerStatistics = (props) => (_jsx(PayoutStatistics, Object.assign({}, props, { className: "payout-seller-statistics", label: "Top Sellers", renderTitle: statistic => statistic.userDisplayName, renderAvatar: statistic => getUserAvatar(statistic.username, statistic.userDisplayName), renderDescription: statistic => `Motty ${statistic.country}` })));
export default PayoutSellerStatistics;
